import { httpClient } from "@allwyn/utils/http-clients/http-client";
import { ForgottenPasswordRequest } from "./models/forgotten-password-request";
import { LoginRequest } from "./models/login-request";
import { LoginResponse } from "./models/login-response";
import { PasswordResetRequest } from "./models/password-rest-request";

const authenticationPath = "/api/authentication";

export async function postLoginData(requestData: LoginRequest): Promise<LoginResponse> {
    const response = await httpClient.post(`${authenticationPath}/login`, requestData);

    if (response.status !== 200) {
        throw new Error(response.data.detail);
    }
    return response.data;
}

export async function postForgottenPassword(requestData: ForgottenPasswordRequest) {
    const response = await httpClient.post(`${authenticationPath}/password/forgotten`, requestData);

    if (response.status !== 204) {
        throw new Error(response.data.detail);
    }
}

export async function postPasswordReset(requestData: PasswordResetRequest) {
    const response = await httpClient.post(`${authenticationPath}/password/reset`, requestData);

    if (response.status !== 204) {
        throw new Error(response.data.detail);
    }
}

export async function postLogout() {
    await httpClient.post(`${authenticationPath}/logout`);
}

export async function postKeepAlive() {
    await httpClient.post(`${authenticationPath}/keep-alive`);
}
